import * as React from 'react';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {RelativeTimestamp} from '../timestamp/relative-timestamp';

import styles from './notification.module.css';

type Props = {
    graphic: React.ReactElement<any> | null | undefined;
    content: string;
    preview: string;
    isRead: boolean;
    createdTime: number;
    onMarkRead: () => any;
    onNavigate: () => any;
};

export function Notification(props: Props) {
    return (
        <div
            onClick={() => {
                props.onMarkRead();
                props.onNavigate();
            }}
            className={styles['notification-container']}
        >
            <div className={props.isRead ? styles.notification : styles['notification--unread']}>
                <div className={styles['profile-picture-container']}>{props.graphic}</div>
                <div className={styles['notification-content-container']}>
                    <StackLegacy spacing={4}>
                        <div
                            dangerouslySetInnerHTML={{__html: props.content}}
                            className={styles.content}
                        />
                        <div
                            dangerouslySetInnerHTML={{__html: props.preview}}
                            className={styles.preview}
                        />
                        <div className={styles.createdTime}>
                            <RelativeTimestamp datetime={props.createdTime} format='calendar' />
                        </div>
                    </StackLegacy>
                </div>
                {!props.isRead ? (
                    <div
                        title='Mark as read'
                        onClick={(e) => {
                            e.stopPropagation();
                            props.onMarkRead();
                        }}
                        className={styles['unread-container']}
                    >
                        <div className={styles['unread-indicator']} />
                    </div>
                ) : undefined}
            </div>
        </div>
    );
}
